import axios from "axios";

export default {
  namespaced: true,
  state: () => ({
    current_query_parcours: null,
    selection: {
      course: "",
      passage: "",
      rassemblement: "",
      challenge: "",
      challenge_equipe: "",
      courses_cumul: "",
      courses_cumul_equipe: "",
    },
    filters: {
      categorie: "Toutes les catégories",
      club: "Tous les clubs",
      keyword: "",
      sexe: "",
    },
    list_categories_filters: [],
    list_club_filters: [],
    id: null,
    data: null,
    resultats_equipes: null,
    clt_sexe_equipe: { "X": 1, "F": 1, "M": 1 }
  }),
  mutations: {
    clearFilters(state) {
      state.filters = {
        categorie: "Toutes les catégories",
        club: "Tous les clubs",
        keyword: "",
        sexe: "",
      };
    },
    clearSelection(state) {
      state.selection = {
        course: "",
        passage: "",
        rassemblement: "",
        challenge: "",
        challenge_equipe: "",
        courses_cumul: "",
        courses_cumul_equipe: "",
      };
    },
    setSelectionFromQuery(state, query) {
      state.id = query.id ? query.id : null;
      state.selection.course = query.p ? query.p : "";
      state.selection.passage = query.i ? query.i : "";
      state.selection.rassemblement = query.r ? query.r : "";
      state.selection.challenge = query.c ? query.c : "";
      state.selection.challenge_equipe = query.ce ? query.ce : "";
      state.selection.courses_cumul = query.cc ? query.cc : "";
      state.selection.courses_cumul_equipe = query.cce ? query.cce : "";
    },

    setQueryParcours(state, query) {
      let new_query = { ...query };
      delete new_query.i;
      state.current_query_parcours = new_query;
    },


    setData(state, data) {
      state.data = data;
    },
    setSelectionCourse(state) {
      if (state.selection.challenge != "" || state.selection.challenge_equipe != "" || state.selection.courses_cumul != "" || state.selection.courses_cumul_equipe != "" || state.selection.rassemblement != "") {
        return;
      }
      if (state.selection.course == "") {
        state.selection.course = state.data.list_courses[0];
        state.current_query_parcours.p = state.selection.course;
      }
    },
    buildCatAndClubFilters(state) {
      state.list_categories_filters = [];
      state.list_club_filters = [];
      for (let i = 0; i < state.data.resultats.length; i++) {
        const cat = state.data.resultats[i].abbrev_categorie;
        const club = state.data.resultats[i].club;
        if (!state.list_categories_filters.includes(cat)) {
          state.list_categories_filters.push(cat);
        }
        if (!state.list_club_filters.includes(club)) {
          state.list_club_filters.push(club);
        }
      }
      state.list_categories_filters.sort();
      state.list_club_filters.sort();
      state.list_categories_filters.unshift("Toutes les catégories");
      state.list_club_filters.unshift("Tous les clubs");
    },

    addEquipe(state, result) {
      const club = result.Club ? result.Club : result.club;
      const equipe_sexe = result.sexe == "M" ? "Hommes" : result.sexe == "F" ? "Femmes" : "Mixtes";
      let equipe = {
        classement: 0,
        classement_sexe: state.clt_sexe_equipe[result.sexe],
        sexe: equipe_sexe,
        nom_equipe: club,
        temps: "00:00:00",
        moye: "",
        coureurs: [result],
        _showDetails: true,
      }
      state.clt_sexe_equipe[result.sexe]++;
      state.resultats_equipes.push(equipe);
    },
    formatResultatsEquipes(state) {
      for (let i = 0; i < state.resultats_equipes.length; i++) {
        const index_last_coureur = state.resultats_equipes[i].coureurs.length - 1;
        state.resultats_equipes[i].temps = state.resultats_equipes[i].coureurs[index_last_coureur].temps;
        state.resultats_equipes[i].moy = state.resultats_equipes[i].coureurs[index_last_coureur].moyenne;
      }
      state.resultats_equipes.sort(function (a, b) {
        let tempsA = a.temps.split(":");
        let tempsB = b.temps.split(":");
        if ((parseInt(tempsA[0]) * 3600 + parseInt(tempsA[1]) * 60 + parseInt(tempsA[2])) < (parseInt(tempsB[0]) * 3600 + parseInt(tempsB[1]) * 60 + parseInt(tempsB[2]))) {
          return -1;
        }
        if ((parseInt(tempsA[0]) * 3600 + parseInt(tempsA[1]) * 60 + parseInt(tempsA[2])) > (parseInt(tempsB[0]) * 3600 + parseInt(tempsB[1]) * 60 + parseInt(tempsB[2]))) {
          return 1;
        }
        return 0;
      });
      for (let i = 0; i < state.resultats_equipes.length; i++) {
        state.resultats_equipes[i].classement = i + 1;
      }
    }
  },
  actions: {
    buildResultatsEquipes({ state, commit, getters }) {

      const resultats = getters.listResultatsUnfiltered;
      state.clt_sexe_equipe = { "X": 1, "F": 1, "M": 1 };
      state.resultats_equipes = [];
      for (let i = 0; i < resultats.length; i++) {
        const result = resultats[i];

        let found_equipe = state.resultats_equipes.find((item) => item.nom_equipe == result.Club || item.nom_equipe == result.club);
        if (found_equipe) {
          found_equipe.coureurs.push(result);
        }
        else {
          commit("addEquipe", result);
        }
      }

      commit("formatResultatsEquipes");
    },
    init({ commit }, query) {
      commit("clearFilters");
      commit("clearSelection");
      commit("setSelectionFromQuery", query);
      commit("setQueryParcours", query);
    },
    async fetch({ state, commit, rootState, getters }) {

      const base_url = rootState.base_url;
      const endpoint = getters.getEndpoint;
      const url = base_url + endpoint;
      try {
        let request = await axios.get(url);
        commit("setData", request.data);
        commit("setSelectionCourse");
        commit("buildCatAndClubFilters");
      }
      catch (error) {
        console.log(error);
      }

    },

    async onChangeQueryParcours({ state, commit, dispatch }, query) {
      commit("clearFilters");
      commit("clearSelection");
      commit("setSelectionFromQuery", query);
    },
  },
  getters: {
    getEndpoint(state) {
      if (state.selection.challenge != '') {
        return "/public/challenge/get.php?id=" + state.id + "&challenge=" + state.selection.challenge;
      }
      if (state.selection.challenge_equipe != '') {
        return "/public/challengeEquipe/get.php?id=" + state.id + "&challenge=" + state.selection.challenge_equipe;
      }
      if (state.selection.courses_cumul != '') {
        return "/public/courseCumul/get.php?id=" + state.id + "&course_cumul=" + state.selection.courses_cumul;
      }
      if (state.selection.courses_cumul_equipe != '') {
        return "/public/courseCumulEquipe/get.php?id=" + state.id + "&course_cumul_equipe=" + state.selection.courses_cumul_equipe;
      }
      return "/public/epreuve/get.php?id=" + state.id + "&course=" + state.selection.course + "&passage=" + state.selection.passage;
    },
    showFilterBar(state, getters) {
      return getters.has_results && !getters.showChallengeResults && !getters.showTeamResults && !getters.showChallengeEquipeResults && !getters.showCoursesCumulResults && !getters.showCoursesCumulEquipeResults;
    },
    has_results(state) {
      return state.data.resultats.length > 0;
    },
    showDefaultResults(state) {
      return state.data.champs_speciaux.type !== 'duo' && state.selection.passage == "";
    },
    showPassagesResults(state) {
      return state.data.champs_speciaux.type !== 'duo' && state.selection.passage !== "";
    },
    showTeamResults(state) {
      return state.data.champs_speciaux.type === 'duo' && state.selection.passage == "";
    },
    showChallengeResults(state) {
      return state.selection.challenge != "";
    },
    showChallengeEquipeResults(state) {
      return state.selection.challenge_equipe != "";
    },
    showCoursesCumulResults(state) {
      return state.selection.courses_cumul != "";
    },
    showCoursesCumulEquipeResults(state) {
      return state.selection.courses_cumul_equipe != "";
    },
    hasCourses(state) {
      return state.data.list_courses.length > 0;
    },
    hasPassagesInter(state) {
      if (!state.data.passages_inter || !state.data.passages_inter.points || state.data.passages_inter.points.length == 0) {
        return false;
      }
      const displayed_passages = state.data.passages_inter.points.filter(point => point.display == 'true');
      const response = displayed_passages && displayed_passages.length > 0;
      return response;
    },
    hasRassemblementsCourse(state) {
      return state.data.rassemblements_course && state.data.rassemblements_course.length > 0;
    },
    hasChallenges(state) {
      return state.data.challenges && state.data.challenges.length > 0;
    },
    hasChallengesEquipe(state) {
      return state.data.challenges_equipe && state.data.challenges_equipe.length > 0;
    },
    hasCoursesCumul(state) {
      return state.data.courses_cumul && state.data.courses_cumul.length > 0;
    },
    hasCoursesCumulEquipe(state) {
      return state.data.courses_cumul_equipe && state.data.courses_cumul_equipe.length > 0;
    },
    isEquipeResults(state) {
      return state.data.champs_speciaux.type == 'duo';
    },
    isLoaded(state) {
      return state.data !== null;
    },
    getOptionsSelectionEpreuve(state, getters) {
      let options = [];
      if (getters.hasCourses) {
        for (let i = 0; i < state.data.list_courses.length; i++) {
          options.push({ value: { id: state.id, p: state.data.list_courses[i] }, text: state.data.list_courses[i] });
        }
      }
      if (getters.hasChallenges) {
        for (let i = 0; i < state.data.challenges.length; i++) {
          options.push({ value: { id: state.id, c: state.data.challenges[i].nom }, text: state.data.challenges[i].nom });
        }
      }
      if (getters.hasChallengesEquipe) {
        for (let i = 0; i < state.data.challenges_equipe.length; i++) {
          options.push({ value: { id: state.id, ce: state.data.challenges_equipe[i].nom }, text: state.data.challenges_equipe[i].nom });
        }
      }
      if (getters.hasCoursesCumul) {
        for (let i = 0; i < state.data.courses_cumul.length; i++) {
          options.push({ value: { id: state.id, cc: state.data.courses_cumul[i].nom }, text: state.data.courses_cumul[i].nom });
        }
      }
      if (getters.hasCoursesCumulEquipe) {
        for (let i = 0; i < state.data.courses_cumul_equipe.length; i++) {
          options.push({ value: { id: state.id, cce: state.data.courses_cumul_equipe[i].nom }, text: state.data.courses_cumul_equipe[i].nom });
        }
      }

      return options;
    },
    getOptionsSelectionPassages(state) {
      let options = [];
      let displayed_passages = state.data.passages_inter.points.filter(point => point.display == 'true');
      options = displayed_passages.map((item) => {
        return { value: item.name, text: item.name };
      });
      options.unshift({ value: "", text: "Arrivée" });
      return options;
    },
    titleResults(state, getters) {

      if (getters.showPassagesResults) {
        return "Passage " + state.selection.passage + " - " + state.selection.course;
      }
      if (getters.showTeamResults) {
        return "Résultats par équipe " + state.selection.course;
      }
      if (getters.showChallengeResults) {
        return "Résultats challenge : " + state.selection.challenge;
      }
      if (getters.showChallengeEquipeResults) {
        return "Résultats challenge équipe : " + state.selection.challenge_equipe;
      }
      if (getters.showCoursesCumulResults) {
        return "Résultats " + state.selection.courses_cumul;
      }
      if (getters.showCoursesCumulEquipeResults) {
        return "Résultats " + state.selection.courses_cumul_equipe;
      }
      if (getters.showDefaultResults) {
        return "Résultats " + state.selection.course;
      }
      return "";
    },
    listResultatsFiltered(state) {
      if (!state.data.resultats) { return []; }
      let results = state.data.resultats;
      const keyword = state.filters.keyword;
      if (!isNaN(keyword)) {
        results = results.filter((item) => (item.numero && item.numero.includes(keyword)));
      }
      else {
        results = results.filter((item) => item.nom.toLowerCase().includes(keyword.toLowerCase()) || item.prenom.toLowerCase().includes(keyword.toLowerCase()));
      }
      const sexeFilter = state.filters.sexe;
      if (sexeFilter != "") {
        results = results.filter((item) => item.sexe == sexeFilter);
      }
      const categorieFilter = state.filters.categorie;
      if (categorieFilter != "Toutes les catégories" && categorieFilter != "") {
        results = results.filter((item) => item.abbrev_categorie == categorieFilter);
      }
      const clubFilter = state.filters.club;
      if (clubFilter != "Tous les clubs" && clubFilter != "") {
        results = results.filter((item) => item.club == clubFilter);
      }

      return results.filter((item) => item.temps_arrondi != '00:00:00' && item.abandon != 'O' && item.disqualifie != 'O');
    },

    listResultatsPassageFiltered(state) {
      if (!state.data.resultats) { return []; }
      let results = JSON.parse(JSON.stringify(state.data.resultats));
      const current_passage = state.selection.passage;
      for (let i = 0; i < results.length; i++) {
        let result = results[i];
        const val_passage = result.passages_inter.find((item) => item.name == current_passage);
        if (val_passage && val_passage.temps) {
          result["Temps"] = val_passage.temps;
          result["temps_arrondi"] = val_passage.temps;
          result["Clt"] = val_passage.clt;
          result["Clt Cat"] = val_passage.clt_cat + " " + result.abbrev_categorie;
          result["Clt Sexe"] = val_passage.clt_sexe + " " + result.sexe;
        }
      }
      results = results.filter((item) => item["Clt"] != '0' && item["Clt"] != 0);
      const keyword = state.filters.keyword;
      if (!isNaN(keyword)) {
        results = results.filter((item) => item.numero.includes(keyword));
      }
      else {
        results = results.filter((item) => item.nom.toLowerCase().includes(keyword.toLowerCase()) || item.prenom.toLowerCase().includes(keyword.toLowerCase()));
      }
      const sexeFilter = state.filters.sexe;
      if (sexeFilter != "") {
        results = results.filter((item) => item.sexe == sexeFilter);
      }
      const categorieFilter = state.filters.categorie;
      if (categorieFilter != "Toutes les catégories" && categorieFilter != "") {
        results = results.filter((item) => item.abbrev_categorie == categorieFilter);
      }
      const clubFilter = state.filters.club;
      if (clubFilter != "Tous les clubs" && clubFilter != "") {
        results = results.filter((item) => item.club == clubFilter);
      }


      return results;
    },

    listFieldsPassage(state) {
      if (!state.data.fields) { return []; }
      let fields = JSON.parse(JSON.stringify(state.data.fields));
      let omit_fields = ["Moy.", "Plus", "Ecart"];
      fields = fields.filter((item) => !omit_fields.includes(item.key));
      return fields;
    },

    listResultatsUnfiltered(state) {
      return state.data.resultats.filter((item) => item.temps_arrondi != '00:00:00' && item.abandon != 'O' && item.disqualifie != 'O');
    },


    getNbCoureurInCat: (state, getters) => (coureur) => {
      const results = getters.listResultatsUnfiltered;
      let in_cat = results.filter((item) => item.categorie == coureur.categorie && item.sexe == coureur.sexe);
      return in_cat.length;
    },
    getNbCoureurInSexe: (state, getters) => (coureur) => {
      const results = getters.listResultatsUnfiltered;
      let in_sexe = results.filter((item) => item.sexe == coureur.sexe);
      return in_sexe.length;
    },



    listResultatsFilteredAsCSV(state, getters) {
      var dataCSV = [];
      const listResultats = getters.listResultatsFiltered;
      for (let i = 0; i < listResultats.length; i++) {
        const fields = state.data.fields;
        const line = listResultats[i];
        let csv_line = {};
        for (let j = 0; j < fields.length; j++) {
          const current_field = fields[j];
          csv_line[current_field.label] = line[current_field.label];
        }
        dataCSV.push(csv_line);
      }
      return dataCSV;
    },
    listResultatsFilteredForPDF(state, getters) {
      let response = [];
      let listResultats = JSON.parse(JSON.stringify(getters.listResultatsFiltered));
      listResultats.sort(function (a, b) {
        if (parseInt(a["Clt"]) < parseInt(b["Clt"])) return -1;
        if (parseInt(a["Clt"]) > parseInt(b["Clt"])) return 1;
        return 0;
      });
      for (var i = 0; i < listResultats.length; i++) {
        var c = listResultats[i];
        response.push([c["Clt"], c["Nom - Prénom"], c["Doss."], c["Clt Cat"], c["Temps"], c["Club"], c["nation"], c["Moy."], c["Ecart"], c["sexe"], c["Clt Sexe"]]);
      }
      return JSON.stringify(response);
    },
    listResultatsEquipesForPDF(state) {
      let response = [];
      if (!state.resultats_equipes) {
        return JSON.stringify(response);
      }
      const listResultats = JSON.parse(JSON.stringify(state.resultats_equipes));
      for (let i = 0; i < listResultats.length; i++) {
        let equipe = listResultats[i];
        let coureurs = [];
        for (let j = 0; j < equipe.coureurs.length; j++) {
          let c = equipe.coureurs[j];
          coureurs.push([c["Clt"], c["Nom - Prénom"], c["Doss."], c["Clt Cat"], c["Temps"], c["Club"], c["nation"], c["Moy."], c["Ecart"], c["sexe"], c["Clt Sexe"]]);
        }
        equipe.coureurs = coureurs;
        response.push(equipe);
      }
      return JSON.stringify(response);
    },
    fieldsForChallengeCoureursItems(state) {
      let fields = state.data.fields;
      fields = fields.filter((item) => item.key != "Nom - Prénom" && item.key != "Ecart" && item.key != "Licence" && item.key != "Club");
      fields.unshift({ key: "course", label: "Course", sortable: false, tdClass: "" });
      return fields;
    },
    fieldsForChallengeEquipeCoureursItems(state) {
      let fields = state.data.fields;
      fields = fields.filter((item) => item.key != "Ecart" && item.key != "Licence" && item.key != "Club");
      fields.unshift({ key: "course", label: "Course", sortable: false, tdClass: "" });
      return fields;
    },
    nbCoursesSelectedChallengeEquipe(state) {
      const selected_challenge_equipe = state.selection.challenge_equipe;
      let challenge_equipe = state.data.challenges_equipe.find((item) => item.nom == selected_challenge_equipe);
      return challenge_equipe ? challenge_equipe.courses.length : 0;
    },
    SelectedChallengeEquipe(state) {
      const selected_challenge_equipe = state.selection.challenge_equipe;
      let challenge_equipe = state.data.challenges_equipe.find((item) => item.nom == selected_challenge_equipe);
      return challenge_equipe ? challenge_equipe : null;
    }
  }

}
